module.exports = __webpack_public_path__ + "img/Frame_12.d3752b9c.png";